import React, { useState } from 'react';
import { FaGift } from 'react-icons/fa';
import TrialRequestModal from './TrialRequestModal';
import { useUserSession } from '../../hooks/useUserSession';
import { usePremiumStatus } from '../../hooks/usePremiumStatus';
import { usePublicConfig } from '../../hooks/usePublicConfig';

/**
 * Bouton pour demander l'essai gratuit (affiché uniquement si éligible et paiements activés).
 * Ouvre une modal de confirmation avant l'envoi de l'email.
 */
function PremiumTrialButton({ eligibleForTrial, onRequestTrial, disabled, className = '' }) {
  const { config } = usePublicConfig();
  const [showModal, setShowModal] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { user } = useUserSession();
  const { requestTrial } = usePremiumStatus();
  const handleRequest = onRequestTrial || requestTrial;

  if (!eligibleForTrial || !config.paymentsEnabled) return null;

  const handleConfirmSuccess = () => {
    setEmailSent(true);
  };

  return (
    <div className={`premium-trial-block ${className}`}>
      <button
        type="button"
        className="premium-trial-button"
        onClick={() => setShowModal(true)}
        disabled={disabled}
      >
        <span className="premium-trial-button-icon">
          <FaGift />
        </span>
        <span className="premium-trial-button-text">{"Activer l'essai gratuit"}</span>
      </button>
      {emailSent && (
        <span className="premium-trial-message">
          <FaGift className="premium-trial-message-icon" />
          Email envoyé ! Consultez votre boîte mail.
        </span>
      )}
      {showModal && (
        <TrialRequestModal
          userEmail={user?.email || null}
          onClose={() => setShowModal(false)}
          onConfirm={async () => {
            const result = await handleRequest();
            if (result.success) {
              handleConfirmSuccess();
            }
            return result;
          }}
        />
      )}
    </div>
  );
}

export default PremiumTrialButton;
